const config = {
	axisLabelScale: 0.06,
	axisTickLabelScale: 0.1,
	axisThickness: 0.005,
	tickLength: 0.03625,
	axisColor: 0x888888,
	thinLineColor: 0x888888
};
export default config;